import React from 'react';
import CommonPage from './CommonPage';
const Terms = () => {
  return (
    <CommonPage title="ব্যবহারের শর্তাবলী">
      আমাদের সেবার শর্তাবলী সম্পর্কে বিস্তারিত শীঘ্রই জানানো হবে।
    </CommonPage>
  );
};
export default Terms;
